import {Card} from "antd";
import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import React from "react";


const ExpensesBuCategoriesGraph = ({dashboardData, formatCurrency}) => {
    return (
        <div style={{marginTop: '20px'}}>
            <Card title="Распределение по категориям">
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={dashboardData.by_category}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={(entry) => `${entry.name}: ${formatCurrency(entry.value)}`}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {dashboardData.by_category.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color || '#8884d8'}/>
                            ))}
                        </Pie>
                        <Tooltip formatter={(value) => formatCurrency(value)}/>
                    </PieChart>
                </ResponsiveContainer>
            </Card>
        </div>
    )
}
export default ExpensesBuCategoriesGraph;